export default __webpack_public_path__ + "static/media/farmacia.e1ac387a.svg";